import { Settings } from 'lucide-react';
import styles from './ContinueOnboardingButton.module.scss';
import { useMutation } from '@tanstack/react-query';
import { accountCabinetOnboardingStart } from '@/fsd/entities/onboarding/api/accountCabinetOnboardingStart/accountCabinetOnboardingStart';
import { queryClient } from '@/fsd/shared/lib/react-query/queryClient';
import { onboardingStore } from '@/fsd/entities/onboarding/model/store/onboardingStore';
import { observer } from 'mobx-react-lite';
import { useGetOnboardingState } from '@/fsd/entities/onboarding/model/hooks/useGetOnboardingState';
import { useNavigate } from 'react-router-dom';

export const ContinueOnboardingButton = observer(() => {
  const { onboardingState } = useGetOnboardingState();
  const navigate = useNavigate();

  // const {
  //   mutateAsync: accountCabinetOnboardingStartMutate,
  //   isPending: isAccountCabinetOnboardingStartMutatePending,
  // } = useMutation({
  //   mutationFn: accountCabinetOnboardingStart,
  //   onSuccess: () =>
  //     queryClient.invalidateQueries({ queryKey: ['onboarding-state'] }),
  // });

  const handleClick = async () => {
    // if (isAccountCabinetOnboardingStartMutatePending) {
    //   return;
    // }
    //
    // if (
    //   onboardingState?.status === 'not_started' ||
    //   onboardingState?.active === false
    // ) {
    //   await accountCabinetOnboardingStartMutate();
    // }
    //
    // onboardingStore.resumeFromSavedStep();
    // onboardingStore.startTour();
    const prevStep = onboardingStore.getPrevStep();
    if (
      prevStep &&
      prevStep.data?.next &&
      window.location.pathname !== prevStep.data.next
    ) {
      navigate(prevStep.data.next);
    }

    onboardingStore.initStore();
  };

  if (
    onboardingStore.show ||
    onboardingState?.status === 'completed' ||
    onboardingState?.status === 'dismissed'
  )
    return null;

  return (
    <div className={styles.button} style={{ width: 135 }} onClick={handleClick}>
      <div className={styles.leftSection}>
        <Settings />
      </div>
      <span className={styles.text}>Продолжить настройку</span>
    </div>
  );
});
